import React, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const StarIcon = forwardRef((props, ref) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { ref: ref }),
        React.createElement("svg", { id: "favourite", xmlns: "http://www.w3.org/2000/svg", width: "23.096", height: "22.384", viewBox: "0 0 23.096 22.384" },
            React.createElement("path", { id: "Path_231", "data-name": "Path 231", fill: "currentColor", fillRule: "evenodd", d: "M22.992,18.735a2,2,0,0,0-1.93-1.414H15.293l-1.817-5.573a2,2,0,0,0-1.927-1.409H11.54a2,2,0,0,0-1.925,1.424L7.851,17.321H2.034A2,2,0,0,0,.1,18.74a2.03,2.03,0,0,0,.742,2.292l4.707,3.436L3.74,30.026a2.03,2.03,0,0,0,.73,2.3,1.983,1.983,0,0,0,2.387.007l4.715-3.442,4.659,3.436a1.984,1.984,0,0,0,2.385.007,2.031,2.031,0,0,0,.745-2.288l-1.769-5.572,4.667-3.442A2.031,2.031,0,0,0,22.992,18.735Z", transform: "translate(0 -10.34)" }))));
});

export { StarIcon };
//# sourceMappingURL=StarIcon.js.map
